var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 114,
    height: 27,
    viewBox: "0 0 114 27",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.519963 14.7372C0.442871 14.472 0.595332 14.1945 0.860492 14.1175L5.18158 12.8612C5.44674 12.7841 5.7242 12.9365 5.80129 13.2017C5.87838 13.4669 5.72591 13.7443 5.46075 13.8214L1.61979 14.9381L2.73648 18.7791C2.81358 19.0442 2.66111 19.3217 2.39595 19.3988C2.13079 19.4759 1.85333 19.3234 1.77624 19.0582L0.519963 14.7372ZM1.24087 14.1594C20.6776 24.84 70.3003 37.082 113.162 0.541238L113.811 1.30223C70.5257 38.2038 20.419 25.8389 0.759287 15.0358L1.24087 14.1594Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.8fe0df8037929a691ca0f164308fbe24.svg";
export { ForwardRef as ReactComponent };